
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ajin-button',
    templateUrl: './button.component.html',
    encapsulation: ViewEncapsulation.None
})

export class  ButtonComponent {
    @Input() label: string | null = null;

    @Input() leftIcon: string | null = null;
    @Input() rightIcon: string | null = null;

    @Input() leftIconSize: 'default' | 'small' = 'default';
    @Input() rightIconSize: 'default' | 'small' = 'default';

    @Input() leftIconColor: string | null = null;
    @Input() rightIconColor:string | null = null;

    @Input()  disabled: boolean = false;

    @Output() click = new EventEmitter<void>();

    constructor( ) {
    }


}


